import React, { Component } from 'react';
import classNames from 'classnames';
import { TaggisLogo, PaddedSection } from '../../atoms';
import { OPTIMIZED_RESIZE } from '../../../utils/optimisedResize';

import './styles.css';

const MQ_SMALL_SCREEN = '(max-width: 1024px)';

/**
 * A template for account-related screens.
 *
 * @typedef {Object} Props
 * @prop {String} content
 * @prop {String} heading
 *
 * @augments {Component<Props>}
 */
export default class Accounts extends Component {

	constructor () {
		// @ts-ignore
		super();

		// Resolves an issue where the body was scrolled before entering this section.
		window.scrollTo({
			behavior: 'instant',
			top: 0,
		});
	}

	state = {
		isSmallScreen: window.matchMedia(MQ_SMALL_SCREEN).matches,
		minHeight: Math.trunc(window.innerHeight),
	};

	componentDidMount () {
		this.mql = window.matchMedia(MQ_SMALL_SCREEN);
		this.mql.addListener(this.handleMediaChange);
		window.addEventListener(OPTIMIZED_RESIZE, this.setInnerHeight);
	}

	componentWillUnmount () {
		this.mql.removeListener(this.handleMediaChange);
		window.removeEventListener(OPTIMIZED_RESIZE, this.setInnerHeight);
	}

	genClassName = (props) => classNames('Accounts', props.className);
	genLhsClassName = (props) => classNames('Accounts-description', props.lhsClassName);

	handleMediaChange = ({ matches }) =>
		this.setState({
			isSmallScreen: !!matches,
		});

	setInnerHeight = () => this.setState({ minHeight: Math.trunc(window.innerHeight) });

	render () {
		const { content, heading } = this.props;
		const { isSmallScreen, minHeight } = this.state;

		return (
			<main className={this.genClassName(this.props)} style={{ minHeight }}>
				{!isSmallScreen
					? <section className={this.genLhsClassName(this.props)}>
						<TaggisLogo className='Accounts-descriptionLogo' />
						<div className='Accounts-descriptionContent'>
							<h1>{heading}</h1>
							<p>{content}</p>
						</div>
					</section>
					: null
				}
				<PaddedSection className='Accounts-primary'>
					{this.props.children}
				</PaddedSection>
			</main>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/Accounts/Accounts.js